__webpack_require__.p = "/GoIT-react-practice/";